<template>
  <div>
    <template>
      <div class="row">
            <div class="col-4">
                <select-input v-model="form.mod_frete.value" :options="form.mod_frete.options" alias="Quem será o resposavel pelo frete?"/>
            </div>
            <div class="col-md-4 d-flex align-items-end" style="padding-left:20px" v-if="form.mod_frete.value != 9">
                <div class="form-group">
                    <b-form-checkbox switch v-model="form.type_shipping.value" inline :value="1" :unchecked-value="0">O frete será feito por uma transportadora?</b-form-checkbox>

                </div>
            </div>
        </div>
        <br />

        <template v-if="form.type_shipping.value == 1">
            <div class="row">
                <div class="col-4">
                    <shipping-company-search v-model="form.transportadora_id.value"/>

                </div>
                <div class="col-2">
                    <text-input alias="Telefone" />
                </div>
                <div class="col-3">
                    <text-input alias="email" />
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <text-input alias="RNTC do Veiculo" v-model="form.RNTC.value" />
                </div>
                <div class="col-2">
                    <text-input alias="Placa do Veiculo" v-model="form.vehicle_plate.value" />
                </div>
                <div class="col-3">
                    <select-input alias="UF" v-model="form.vehicle_uf.value" :options="form.vehicle_uf.options" />
                </div>
            </div>
        </template>

        <div class="row" v-if="form.mod_frete.value != 9">
            <div class="col-4">
                <text-input alias="Nº de indentificação dos volumes" v-model="form.indentidica_volume.value" />
            </div>
            <div class="col-2">
                <text-input alias="Quantidade de Volumes" v-model="form.quantity_volume.value" />
            </div>
            <div class="col-2">
                <text-input alias="Tipo de Volume" v-model="form.type_volume.value" />
            </div>
            <div class="col-2">
                <number-input alias="Peso Bruto Total" v-model="form.peso_bruto.value" />
            </div>
            <div class="col-2">
                <number-input alias="Peso Liquido Total" v-model="form.peso_liquido.value" />
            </div>
      </div>
    </template>
  </div>
</template>

<script>
import Form from "./../../mixins/Form";
import ShippingCompanySearch from "./../ShippingCompanySearch";

export default {
  components: {
    ShippingCompanySearch
  },

  props: {
    value: {},
    form: {}
  },

  data() {
    return {



        //shipping
        type_shipping: {
          value: 0
        },

        add_shipping_value: {
          value: 1
        },

        mod_frete: {
          value: 9,
          options: {
            0: "Contratação do Frete por conta do Remetente(CIF)",
            1: "Contratação do Frete por conta do Destinatário(FOB)",
            2: "Contratação do Frete por conta de Terceiros",
            3: "Transporte Próprio por conta do Remetente",
            4: "Transporte Próprio por conta do Destinatário",
            9: "Sem Ocorrência de Transporte"
          }
        },

        shipping_value: {},

        transportadora_id: {},

        vehicle_plate: {},

        vehicle_uf: {
          options: {
            AC: "Acre",
            AL: "Alagoas",
            AM: "Amazonas",
            AP: "Amapá",
            BA: "Bahia",
            CE: "Ceará",
            DF: "Distrito Federal",
            ES: "Espírito Santo",
            GO: "Goiás",
            MA: "Maranhão",
            MT: "Mato Grosso",
            MS: "Mato Grosso do Sul",
            MG: "Minas Gerais",
            PA: "Pará",
            PB: "Paraíba",
            PR: "Paraná",
            PE: "Pernambuco",
            PI: "Piauí",
            RJ: "Rio de Janeiro",
            RN: "Rio Grande do Norte",
            RS: "Rio Grande do Sul",
            RO: "Rondônia",
            RR: "Roraima",
            SC: "Santa Catarina",
            SP: "São Paulo",
            SE: "Sergipe",
            TO: "Tocantins"
          }
        },

        RNTC: {},

        indentidica_volume: {},

        quantity_volume: {},

        type_volume: {},

        peso_bruto: {},

        peso_liquido: {}
        //end shipping

    };
  },

};
</script>

<style>
</style>
